import { createFileRoute, Outlet } from "@tanstack/react-router";

/*
 * Layout-only route. `domains.$domainId` is a CHILD of this route, so whatever
 * component sits here also renders for the detail URL, and the child appears
 * only where this component puts its <Outlet />. Rendering the list page
 * directly here swallows the detail page: the URL changes, the list stays.
 * Keep the list in domains.index.tsx and leave this a bare outlet.
 */
export const Route = createFileRoute("/portal/domains")({
  component: DomainsLayout,
});

function DomainsLayout() {
  return <Outlet />;
}
